import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import { BLANK_PAGE_ROUTE } from '@routes';
import { replaceCancelButtonAction } from './helpers';

const CreateNewDelegate = () => {
  const history = useHistory();
  const location = useLocation();

  const redirectFn = () => {
    history.push('create-new-delegate');
  };

  return (
    <V2SettingsIframe
      iframeSrc={`/aware/?embed=1&leftSrc=/webmanager/curriculum/delegatelist2.aspx&detailsSrc=${BLANK_PAGE_ROUTE}&rightSrc=/webmanager/curriculum/adddelegate.aspx`}
      title="Create New Delegate"
      key={location.key}
      onLoadCallback={iframe =>
        replaceCancelButtonAction({ iframe, id: 'panelright1', redirectFn })
      }
    />
  );
};

export default CreateNewDelegate;
